<template>
  <div class="tab-container">
    <h4>{{ $t("game.homeView.accountSettings.deleteAccount.title") }}</h4>
    <i18n-t keypath="game.homeView.accountSettings.deleteAccount.deleteAccountDesc1" tag="p">
      <template #link>
        <span class="virtual-link" @click="crisp.chat.open()"> {{ $t("game.homeView.accountSettings.deleteAccount.customerService") }} </span>
      </template>
    </i18n-t>
    <p class="small">{{ $t("game.homeView.accountSettings.deleteAccount.deleteAccountDesc2") }}</p>
    <p>
      <a :href="campaignLanguage == 'fr' ? 'https://yuzu.hr/legal/cgu.pdf' : 'https://yuzu.hr/en/condition-generales-d-utilisation'" target="_blank">{{ $t("game.loginView.termsLink") }}</a>
      |
      <a :href="campaignLanguage == 'fr' ? 'https://yuzu.hr/legal/privacy.pdf' : 'https://www.yuzu.hr/en/politique-de-confidentialite'" target="_blank">{{ $t("game.loginView.privacyLink") }}</a>
    </p>
  </div>
</template>

<script setup>
import { reactive, computed, inject } from "vue";
const { locale } = useI18n();

const crisp = inject("crisp");

const state = reactive({
  explaination: "",
  password: "",
});

const campaignLanguage = computed(() => {
  return (locale?.value || 'fr');
});

const canDelete = computed(() => {
  return state.explaination && state.password.length > 7;
});
</script>
